/**
 * 获取头部导航信息
 */
import 'babel-polyfill'

function getHeaderNavInfo () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/common/platformNav?platformId=xfyun',
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

function getHeaderDataFromCms () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/index/newheader',
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

export {
  getHeaderNavInfo,
  getHeaderDataFromCms
}



// WEBPACK FOOTER //
// ./src/js/api/header.js